import React from 'react';
import classnames from 'classnames';
import Color from '../color';
import buttonsClasses from '../../../styles/buttons.scss';
import classes from './color-label.scss';
export const ColorLabel = props => {
  const {
    colorName,
    colorValue,
    className,
    labelClassName,
    circleClassName,
    style,
    textRef,
    tooltipText,
    onClick = () => undefined
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: classnames(buttonsClasses.blackTextBorderedButton, className),
    style: style
  }, /*#__PURE__*/React.createElement(Color, {
    color: colorValue,
    tooltipText: tooltipText,
    className: classnames(classes.colorCircle, circleClassName)
  }), /*#__PURE__*/React.createElement("span", {
    ref: textRef,
    "data-color-name": colorName,
    className: classnames(classes.colorName, labelClassName)
  }, colorName));
};